import { platformCreditParameters } from '@/shared/api/resources';
import { useAuth } from '@/shared/auth/useAuth';
import { Alert } from '@/shared/ui/Alert';
import { PageHeader } from '@/shared/ui/PageHeader';

import { EditorDeParametros } from './EditorDeParametros';
import type { EscopoDoEditor } from './escopo';

/**
 * Padrao global dos parametros de credito, na administracao da plataforma.
 *
 * O mesmo editor da empresa, com as rotas da plataforma. Quem administra a plataforma
 * edita e ativa o padrao global; a empresa que herda recebe um rascunho a cada versao
 * global nova, e o rascunho nunca entra em vigor sozinho. A segregacao vale aqui
 * tambem: quem editou a versao nao a ativa.
 */
export function PlatformCreditParametersPage() {
  const { session } = useAuth();
  const administra = session?.platform_admin === true;

  const escopo: EscopoDoEditor = {
    tipo: 'plataforma',
    api: platformCreditParameters,
    chave: 'plataforma-credito-parametros',
    podeEditar: administra,
    podeAtivar: administra,
  };

  return (
    <div className="flex flex-col gap-5">
      <PageHeader
        title="Padrao global da analise de credito"
        description="Parametros do motor de credito publicados para as empresas que herdam o padrao global."
      />
      <Alert tone="info" title="O padrao global nao ativa nada nas empresas">
        Uma versao global nova abre um rascunho em cada empresa que herda. A empresa
        revisa e ativa o rascunho, com justificativa, por quem tem a permissao de
        aprovar.
      </Alert>
      <EditorDeParametros escopo={escopo} />
    </div>
  );
}
